import { render } from "./Call.vue?vue&type=template&id=51591bf4&scoped=true"
import script from "./Call.vue?vue&type=script&lang=js"
export * from "./Call.vue?vue&type=script&lang=js"

import "./Call.vue?vue&type=style&index=0&id=51591bf4&scoped=true&lang=css"

import exportComponent from "D:\\lxq\\nkpcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51591bf4"]])

export default __exports__